import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'

/**
 * Wire the Android hardware back button to Vue Router.
 *
 * Behaviour:
 *  - If there is history to go back to  → router.back()
 *  - If we are already at the root ("/") → exit the app
 *  - Double-tap-to-exit guard: two back presses within 2 s exits,
 *    a single press shows a toast "Press back again to exit"
 */
export function registerBackButton(router) {
  if (!Capacitor.isNativePlatform()) return

  let backPressedOnce = false

  App.addListener('backButton', () => {
    // If a modal/drawer is open let the default dismiss handle it first.
    // (The components themselves call event.stopPropagation equivalents.)

    const canGoBack = window.history.length > 1 && router.currentRoute.path !== '/'

    if (canGoBack) {
      router.back()
      return
    }

    // At root — double-tap to exit
    if (backPressedOnce) {
      App.exitApp()
      return
    }

    backPressedOnce = true

    // Show a brief toast if the Vue-notification plugin is available
    if (window.__vueRoot__?.$notify) {
      window.__vueRoot__.$notify({
        group: 'default',
        type: 'info',
        title: '',
        text: 'Press back again to exit',
        duration: 2000,
      })
    }

    setTimeout(() => { backPressedOnce = false }, 2000)
  })
}
